// \src\models\daily-utilizations.ts
import { DayOfWeek } from './day-of-week';
import { TimeWindow } from './time-window';

export class DailyUtilization {
  public dayOfWeek: DayOfWeek | undefined;
  public timeWindows: Array<TimeWindow> | undefined;

  constructor(dayOfWeek?: DayOfWeek) {
    this.dayOfWeek = dayOfWeek;
    this.timeWindows = []; // Initialize timeWindows as an empty array
  }
}
